import { cn } from "../lib/utils.js";
import { Skeleton } from "./skeleton.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
//#region src/components/card.tsx
const cardVariants = cva(" tw:flex tw:flex-col tw:gap-4 tw:rounded-sm tw:border tw:p-6", { variants: { variant: {
	outlined: "tw:bg-white tw:border-stroke",
	shaded: "tw:bg-[#f7f8fd] tw:new:bg-sidebar/70 tw:border-[#eee] tw:new:border-concrete/10"
} } });
function Card({ className = "", variant = "outlined", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card",
		className: cn(cardVariants({ variant }), className),
		...props
	});
}
function CardHeader({ className = "", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-header",
		className: cn("tw:@container/card-header tw:grid tw:auto-rows-min tw:grid-rows-[auto_auto] tw:items-start tw:gap-1.5 tw:has-data-[slot=card-action]:grid-cols-[1fr_auto] tw:[.border-b]:pb-6", className),
		...props
	});
}
function CardTitle({ className = "", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-title",
		className: cn("tw:font-denim tw:font-medium tw:text-[#333] tw:new:text-midnight tw:text-xl", className),
		...props
	});
}
function CardDescription({ className = "", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-description",
		className: cn("tw:text-[#525257] tw:new:text-midnight/70 tw:text-sm", className),
		...props
	});
}
function CardAction({ className = "", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-action",
		className: cn("tw:col-start-2 tw:row-span-2 tw:row-start-1 tw:self-start tw:justify-self-end", className),
		...props
	});
}
function CardContent({ className = "", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-content",
		className: cn("", className),
		...props
	});
}
function CardFooter({ className = "", ...props }) {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-footer",
		className: cn("tw:flex tw:items-center", className),
		...props
	});
}
const CardSkeleton = ({ rows = 3, ...props }) => /* @__PURE__ */ jsxs(Card, {
	...props,
	"aria-hidden": true,
	children: [/* @__PURE__ */ jsx(CardHeader, { children: /* @__PURE__ */ jsx(Skeleton, { className: "tw:my-1 tw:h-6 tw:w-48 tw:max-w-full" }) }), /* @__PURE__ */ jsx(CardContent, {
		className: "tw:space-y-2",
		children: Array.from({ length: rows }, (_, index) => /* @__PURE__ */ jsx(Skeleton, { className: "tw:h-4 tw:w-full tw:last:w-2/3" }, index))
	})]
});
//#endregion
export { Card, CardAction, CardContent, CardDescription, CardFooter, CardHeader, CardSkeleton, CardTitle };

//# sourceMappingURL=card.js.map